import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { User } from './master-visualizar-meu-cadastro.model';

const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class MasterVisualizarMeuCadastroService {
  constructor(private httpClient: HttpClient) {}

  getUserByEmail(payload?: any): Observable<any> {
    if (payload === null || payload === undefined) {
      return throwError('Required parameter e-mail was null or undefined.');
    }

    return this.httpClient
      .post<any>(`${BASE_PATH}/bff/users/myAccount`, payload)
      .pipe(retry(2), catchError(null));
  }
}
